module.exports = __webpack_public_path__ + "img/bush.5aec0a09.svg";